(function () {
  const rootUrl = () => window.Shopify?.routes?.root || '/';

  function route(path) {
    return `${rootUrl()}${path.replace(/^\//, '')}`;
  }

  async function parseResponse(response) {
    const contentType = response.headers.get('content-type') || '';
    const body = await response.text();
    let payload = body;
    if (contentType.includes('application/json') || contentType.includes('text/javascript')) {
      try {
        payload = JSON.parse(body);
      } catch (_error) {
        payload = body;
      }
    }
    if (!response.ok) {
      const message = typeof payload === 'object' ? payload.description || payload.message || response.statusText : response.statusText;
      throw new Error(message);
    }
    return payload;
  }

  async function request(url, options) {
    const response = await fetch(url, options);
    return parseResponse(response);
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach((node) => {
      node.textContent = String(count);
      node.hidden = count === 0;
    });
    document.querySelectorAll('[data-cart-trigger]').forEach((trigger) => {
      const countLabel = trigger.dataset.cartLabelCount || '';
      const emptyLabel = trigger.dataset.cartLabelEmpty || countLabel;
      trigger.setAttribute('aria-label', count > 0 ? countLabel.replace('[count]', String(count)) : emptyLabel);
    });
  }

  async function addItem(formData) {
    document.dispatchEvent(new CustomEvent('rm:cart:adding'));
    return request(route('cart/add.js'), {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData,
    });
  }

  async function changeLine(id, quantity) {
    return request(route('cart/change.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id, quantity }),
    });
  }

  async function updateCart(data) {
    return request(route('cart/update.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(data),
    });
  }

  async function getCart() {
    return request(route('cart.js'), { headers: { Accept: 'application/json' } });
  }

  async function getSections(sectionIds, signal) {
    const sections = Array.isArray(sectionIds) ? sectionIds.join(',') : sectionIds;
    return request(`${rootUrl()}?sections=${encodeURIComponent(sections)}`, {
      headers: { Accept: 'application/json' },
      signal,
    });
  }

  function replaceSectionContent(sectionHtml, selector, currentRoot) {
    if (!sectionHtml) return false;
    const parsed = new DOMParser().parseFromString(sectionHtml, 'text/html');
    const next = parsed.querySelector(selector);
    const current = currentRoot ? currentRoot.querySelector(selector) : document.querySelector(selector);
    if (!next || !current) return false;
    window.RotaTheme?.destroy(current);
    current.replaceWith(next);
    window.RotaTheme?.init(next);
    return true;
  }

  function announceUpdated(cart) {
    updateCartCount(cart.item_count);
    document.dispatchEvent(new CustomEvent('rm:cart:updated', { detail: { cart } }));
  }

  window.RotaCartAPI = {
    addItem,
    changeLine,
    updateCart,
    getCart,
    getSections,
    replaceSectionContent,
    updateCartCount,
    announceUpdated,
  };
})();
